module.exports = __webpack_public_path__ + "16ddb1541046ada9b90cacf4adec839a.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto-v15-latin-300.woff2
// module id = 1089
// module chunks = 0